import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 36, className = '' }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y, scale: 0.97 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);
